var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group" }, [
    _c(
      "div",
      [
        _vm._l(_vm.propValue, function (item) {
          return [
            _c(item.component, {
              key: item.id,
              tag: "component",
              staticClass: "component",
              style: item.groupStyle,
              attrs: {
                id: "component" + item.id,
                "prop-value": item.propValue,
                element: item,
              },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }